// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1NqgM","title":"Header_title__vhZ5k","left":"Header_left__pHUhD","clinicName":"Header_clinicName__m0a6q"};